import axios from 'axios';

const baseURL = 
`${process.env.REACT_APP_API_BASE_URL || 'http://localhost:9091'}/api`;

console.log(process.env.REACT_APP_API_BASE_URL);
const API = axios.create({ baseURL });

export const authLogin = (username: string, password: string) => 
  API.post('auth/login', { username, password });
      
export const getBuildings = () => API.get('/buildings');
export const createBuilding = (data: FormData) => API.post('/buildings', data);
export const updateBuilding = (id: number, data: FormData) => API.put(`/buildings/${id}`, data);
export const deleteBuilding = (id: number) => API.delete(`/buildings/${id}`);
export const getVacantBuildings = () => API.get('/buildings/vacant');
export const getTeamMembers = () => API.get('/team');
export const createTeamMember = (data: any) => API.post('/team', data);
export const updateTeamMember = (id: number, data: any) => API.put(`/team/${id}`, data);
export const deleteTeamMember = (id: number) => API.delete(`/team/${id}`);
export const submitMessage = (data: any) => API.post('/message', data);
export const getMessages = () => API.get('/message');
export const deleteMessage = (id: number) => API.delete(`/message/${id}`);
export const updateMessage = (id: number) => API.put(`/message/${id}`);
export const getContact = () => API.get('/contact');
export const updateContact = (data: any) => API.post('/contact', data);
export const saveSetting = (data: any) => API.post('/setting', data);
export const getSetting = () => API.get('/setting');
export const fetchImage = (fsId: string) => API.get(`/files/${fsId}`, {
  responseType: 'blob'
});

export default API;
